import { OrganizationDto } from "@dialogics/shared/dto/types"
import { ColumnDef, Row } from "@tanstack/react-table"
import { useModal } from "@component/modal.ts"
import { ReactTailwindTable, useTable } from "@component/react-tailwind-table.tsx"
import { OrganizationForm } from "./organization-form"
import { useGetOrganizationsQuery } from "./organization-service"
import { useSelection } from "@/app/department-context.tsx"

export const OrganizationListPage = () => {
  const { currentOrganization, setCurrentOrganization } = useSelection()
  const { pagination, setPagination } = useTable({
    defaultPageSize: 10,
  })
  const {
    isOpen: isFormOpen,
    openModal: openForm,
    closeModal: closeForm,
    data: organization,
  } = useModal<OrganizationDto>()

  const columns: ColumnDef<OrganizationDto>[] = [
    {
      accessorKey: "name",
      header: "Имя",
    },
    {
      accessorKey: "title",
      header: "Название",
    },
    {
      id: "actions",
      cell: ({ row }: { row: Row<OrganizationDto> }) => (
        <div>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => setCurrentOrganization(row.original)}
            disabled={currentOrganization?.id === row.original.id}
          >
            {currentOrganization?.id === row.original.id ? "Выбрано" : "Выбрать"}
          </button>
          <button className="btn btn-sm btn-secondary ml-2" onClick={() => openForm(row.original)}>
            Редактировать
          </button>
        </div>
      ),
    },
  ]

  return (
    <div className="max-w-7xl mx-auto bg-white dark:bg-base-200 p-6 sm:p-8 rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl">Организации</h1>
        <button className="btn btn-primary" onClick={() => openForm()}>
          Создать организацию
        </button>
      </div>
      <ReactTailwindTable
        query={useGetOrganizationsQuery}
        columns={columns}
        pagination={pagination}
        setPagination={setPagination}
      />
      <OrganizationForm isOpen={isFormOpen} onClose={closeForm} organization={organization ?? undefined} />
    </div>
  )
}
